var map = {
	"./actions": 2472,
	"./actions.json": 2472,
	"./components": 2473,
	"./components.json": 2473,
	"./directory": 2474,
	"./directory.json": 2474,
	"./eCircular": 2475,
	"./eCircular.json": 2475,
	"./en-us": 2476,
	"./en-us.json": 2476,
	"./errors": 2477,
	"./errors.json": 2477,
	"./hints": 2478,
	"./hints.json": 2478,
	"./project": 2479,
	"./project.json": 2479,
	"./regionalWorkPermitLabels": 2480,
	"./regionalWorkPermitLabels.json": 2480,
	"./settings": 2481,
	"./settings.json": 2481,
	"./table": 2482,
	"./table.json": 2482,
	"./tenancy": 2483,
	"./tenancy.json": 2483,
	"./tenantProject": 2484,
	"./tenantProject.json": 2484,
	"./tenders": 2485,
	"./tenders.json": 2485,
	"./userGuideForms": 2486,
	"./userGuideForms.json": 2486,
	"./workPermit": 2487,
	"./workPermit.json": 2487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3188;